import SkillNodePurchaseListener from "../SkillNodePurchaseListener";
import NumberValueSkillNode from "./NumberValueSkillNode";

export default class TileRangeSkillNode extends NumberValueSkillNode {
    /**
     * @param {string} id 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {SkillNodePurchaseListener} purchaseListener
     * @param {number} valuePerSkillLevel
     * @param {NumberValue} numberValue
     * @param {number} minRange
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue, minRange) {
        super(id, '+' + valuePerSkillLevel + ' Tile', 
            null, totals, iconFileName, cost, purchaseListener, valuePerSkillLevel, numberValue);

        this.minRange = minRange;
    }

    /**
     * @returns {string}
     */
    getDescription() {
        const range = (this.minRange + (this.valuePerSkillLevel * this.numberValue.getValue()));
        return 'Range: ' + range + ' Tiles'
    }

}